import type { FilterEntitySourceId } from "building-types/buildingGraphFilter/entitySource";
import type { EntityFilterSource } from "./entityFilterSourceTypes";
import { ENTITY_FILTER_SOURCES } from "./sources/entityFilterSources";

export function getEntitySource<T extends FilterEntitySourceId>(sourceId: T): EntityFilterSource<T> {
  const source = ENTITY_FILTER_SOURCES[sourceId];
  if (!source) {
    throw new Error(`No entity source registered for "${sourceId}"`);
  }
  return source as unknown as EntityFilterSource<T>;
}
